<template>
  <div class="progress-parameters">
    <v-container>
      <v-row class="border">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="6">
              <p>
                {{ $ucfirst($t("general.parameter", {catalog: "app_mobile"})) }}
              </p>
              <v-select
                v-model="selectedParameterValue"
                :items="keysParametersSelect"
                outlined
                @change="parameterChange()"
            /></v-col>
            <v-col cols="12" lg="6">
              <p>{{ $ucfirst($t("pa.period")) }}</p>
              <v-select
                v-model="selectedPeriodValue"
                :items="keysPeriodSelect"
                outlined
                @change="periodChange"
                :disabled="keysPeriodSelect.length === 1"
              />
            </v-col>
          </v-row>
          <v-row class="ml-1" align="center">
            <p>
              {{ $ucfirst($t("journeyParameters.relatedGoals")) }}:
            </p>
            <div
              v-for="relatedBehaviourChangeGoal in selectedParameterRelatedBehaviourChangeGoals"
              :key="relatedBehaviourChangeGoal.key"
            >
              <p class="mx-4 pa-2 border progress-parameters__related-goals">
                <v-icon class="mr-2">{{
                  behaviourComponents[relatedBehaviourChangeGoal].icon
                }}</v-icon>
                {{ $app.behaviourComponentManager.getBehaviourComponentName(relatedBehaviourChangeGoal) }}
              </p>
            </div>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <apexchart
                type="line"
                height="390"
                :options="chartOptions"
                :series="series"
                :style="{
                  'padding-right': !chartHasLegends ? legendWidth + 4 + 'px' : 0
                }"
              ></apexchart>
            </v-col>
          </v-row>
          <!----------------------------------------- Time line ----------------------------------------->
          <v-row class="ma-2 ml-0" no-gutters>
            <v-col cols="12">
              <v-row class="no-gutters">
                <!-- Icons -->
                <v-col cols="1" sm="2" md="1" class="pl-5" ref="timelineIcons">
                  <v-row class="align-self-center mt-9">
                    <v-col
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'MEDICATIONS'
                        )
                      "
                      cols="12"
                      class="border c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                    >
                      <div class="pa-1 px-3">
                        <smart-icon icon="mdi-pill" />
                      </div>
                    </v-col>

                    <v-spacer
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'MEDICATIONS'
                        )
                      "
                    />
                    <v-col
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'STARTMOVING'
                        )
                      "
                      cols="12 border c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                    >
                      <div class="pa-1 px-3">
                        <smart-icon icon="mdi-run" />
                      </div>
                    </v-col>
                    <v-spacer
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'HEALTHYNUTRITION'
                        )
                      "
                    />
                    <v-col
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'HEALTHYNUTRITION'
                        )
                      "
                      cols="12 border c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                    >
                      <div class="pa-1 px-3">
                        <smart-icon icon="mdi-silverware-fork-knife" />
                      </div>
                    </v-col>
                    <v-spacer
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'MEDICATIONS'
                        )
                      "
                    />
                    <v-col
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'SMOKECESSATION'
                        )
                      "
                      cols="12 border c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                    >
                      <div class="pa-1 px-3">
                        <smart-icon icon="mdi-smoking-off" />
                      </div>
                    </v-col>
                    <v-spacer
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'SMOKECESSATION'
                        )
                      "
                    />
                    <v-col
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'STRESSMANAGEMENT'
                        )
                      "
                      cols="12 border c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                    >
                      <div class="pa-1 px-3">
                        <smart-icon icon="mdi-meditation" />
                      </div>
                    </v-col>
                    <v-spacer
                      v-if="
                        selectedParameterRelatedBehaviourChangeGoals.includes(
                          'STRESSMANAGEMENT'
                        )
                      "
                    />
                  </v-row>
                </v-col>
                <!-- Chart -->
                <v-col cols="9" sm="8" md="9">
                  <apexchart
                    type="rangeBar"
                    :height="
                      50 * selectedParameterRelatedBehaviourChangeGoals.length +
                      50
                    "
                    width="100%"
                    :options="chartOptionsTimeLine"
                    :series="seriesTimeLine"
                    class="progress-parameters__timeline"
                  ></apexchart>
                </v-col>
                <v-col cols="2" ref="timelineLegends">
                  <div class="c-timeline__legend-wrapper pl-9">
                    <div
                      v-for="legend in legends"
                      class="c-timeline__legend"
                      :key="legend.name"
                    >
                      <v-icon small :color="legend.color">mdi-circle</v-icon>
                      <p class="mb-0 ml-1">{{legend.name}}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* import gql from "graphql-tag"; */
/* import moment from "moment"; */
/* import Timeline from "../../../components/Parts/Timeline/Timeline"; */
/* // import DatePicker from "../../../components/Parts/DatePicker"; */
/* import { debounce } from "debounce"; */
/* import { uniqueValues } from "../../../../../helper/arrays"; */
/* import DocumentsPerCategory from "../../../components/Parts/DocumentsPerCategory"; */
/* import LabelPicker from "../../../components/Parts/LabelPicker"; */
/* import PatientDocument from "../../../../../model/PatientDocument"; */
import gql from "graphql-tag";
import moment, { months } from "moment";
import JourneyProgressTabs from "../../../components/Parts/JourneyProgressTabs.vue";
import JourneyButtonLine from "../../../components/Parts/JourneyButtonLine.vue";
import VueApexCharts from "vue-apexcharts";
import SmartIcon from "../../../components/Parts/SmartIcon.vue";
import { mapGetters } from "vuex";
import {UCUMUnit} from "../../../../../helper/UCUMUnit";
import app from "../../../../app";

/**
 * Component ProgressStatusParameters.vue
 *
 * @module ProgressStatusParameters
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/ProgressStatusParameters.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  props: ['p'],
  name: "ProgressStatusParameters",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      weightUnitSetting: "patientSummary/weightUnit",
      lipidsUnitSetting: "patientSummary/cholesterolLDLPreferredUnit",
      glucoseUnitSetting: "patientSummary/glucosePreferredUnit",
      bloodPressureUnitSetting: "patientSummary/bloodPressureUnit",
      length: "patientSummary/length",
      hadEvent: "patientSummary/hadSecondVascularEventOnStatins",
    }),
    visit1Date() {
      const v1 = this.$store.getters["patientSummary/visit1Date"];
      return v1 ? moment(v1) : moment();
    },
    chartOptions: function () {
      return {
        chart: {
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          ...this.$app.apexChartHelper.getMonthTranslations()
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        colors: this.getLineChartColors(),
        grid: {
          padding: {
            left: 25,
          },
        },
        xaxis: {
          type: "datetime",
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.85rem',
            },
            offsetY: 15,
          },
          min: this.xAxisMin,
          max: this.xAxisMax,
          labels: {
            datetimeFormatter: {
              year: "MMMM 'yy",
              month: "MMMM 'yy",
              day: "dd MMMM",
              hour: "HH:mm"
            },
            rotate: -30,
            minHeight: 90,
            rotateAlways: true,
            hideOverlappingLabels: true,
            style: {
              fontSize: '0.75rem',
            }
          }
        },
        annotations: {
          position: 'back',
          yaxis: this.setAnnotationsGraph(),
        },
        yaxis: {
          title: {
            text: this.getYAxisTitle(),
            style: {
              fontSize: '0.85rem',
            },
            offsetX: -15,
          },
          labels: {
            style: {
              fontSize: '0.75rem',
            },
            minWidth: this.yAxisWidth,
            formatter: (val) => {
              const precision = this.getParameterValuePrecision();
              return typeof val !== 'undefined' ? val.toFixed(precision) : null;
            }
          },
          min: this.yAxisOverTimeMin,
          max: this.yAxisOverTimeMax,
        },
        legend: {
          show: true,
          position: "right",
          offsetY: 120,
          offsetX: -48,
          fontSize: '16px',
          itemMargin: {
            vertical: 4
          },
          width: this.legendWidth
        },
        tooltip: {
          x: {
            formatter: (value) => {
              const groupBy = this.getDataPointGroupPeriod();

              const startDate = moment(value).format('DD');
              const startMonth = moment(value).format('MM');
              const startMonthName = this.$ucfirst(this.$t(`date.MMMM-${startMonth}`));

              if (groupBy === 'day') {
                return `${startDate} ${startMonthName}`
              } else {
                const endDate = moment(value).endOf(groupBy).format('DD');
                const endMonth = moment(value).endOf(groupBy).format('MM');
                const endMonthName = this.$ucfirst(this.$t(`date.MMMM-${endMonth}`));
                return `${startDate} ${startMonthName} - ${endDate} ${endMonthName}`
              }
            }
          },
          y: {
            formatter: (val) => {
              const precision = this.getParameterValuePrecision();
              return typeof val !== 'undefined' ? `${val.toFixed(precision)} ${this.selectedParameterUnit}` : this.selectedParameterUnit;
            }
          },
          style: {
            fontSize: '0.85rem',
          }
        },
        markers: {
          size: 4,
          strokeWidth: 1,
          hover: {
            size: 6,
          }
        },
      };
    },
    chartOptionsTimeLine: function () {
      return {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          width: "100%",
          type: "rangeBar",
          ...this.$app.apexChartHelper.getMonthTranslations(),
          events: {
            mounted: (chartContext) => {
              this.timelineWidth = chartContext.el.clientWidth
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            borderRadius: 10,
            barHeight: "50%",
            dataLabels: {
              hideOverflowingLabels: true,
            },
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value, { seriesIndex, dataPointIndex, w }) => {
              return this.getBehaviourComponentLabel(
                w.config.series[seriesIndex].data[dataPointIndex].x,
                w.config.series[seriesIndex].data[dataPointIndex].name
              );
            },
          },
          x: {
            format: 'dd MMMM',
          }
        },
        dataLabels: {
          enabled: true,
          formatter: (val, { seriesIndex, dataPointIndex, w }) => {
            // To avoid overlapping labels at the start of the bar:
            // Calculate the width from the start till middle of each bar to be able to move the label to this position

            // gridWidth - starting from x axis min
            // this.timelineWidth - whole chart width - includes overflowing part of bars at the start
            const name = w.config.series[seriesIndex].data[dataPointIndex].name
            const xAxisMinValue = w.config.xaxis.min;
            const gridWidth = w.globals.gridWidth;
            const overChartDifferenceWidth = this.timelineWidth - gridWidth;
            const timelinePeriod = moment().diff(moment(xAxisMinValue));
            const overChartDifferencePeriod = overChartDifferenceWidth * timelinePeriod / gridWidth
            const endOfBarFromStartPeriod = moment(val[1]).diff(moment(xAxisMinValue))
            const endOfBarFromStartWidth = (gridWidth * endOfBarFromStartPeriod / timelinePeriod) + overChartDifferenceWidth
            const barWidth = gridWidth * (val[1] - val[0]) / timelinePeriod
            const barMiddle = moment(val[0]).isAfter(moment(xAxisMinValue).add(-moment(overChartDifferencePeriod)))
              ? barWidth / 2
              : (endOfBarFromStartWidth / 2) - 6
            const middleOfBarFromStartWidth = endOfBarFromStartWidth - barMiddle

            // 43 - first label position ( default )
            const isBefore = middleOfBarFromStartWidth < 43 + overChartDifferenceWidth
            const isGone = middleOfBarFromStartWidth < 0

            // find label in DOM and set new position
            if (isBefore && +name !== 0) {
              const chartId = w.globals.chartID
              setTimeout(() => {
                const labels = document.querySelectorAll(`#apexcharts${chartId} .apexcharts-datalabels g text`)
                const label = labels[dataPointIndex]
                if (label) {
                  label.setAttribute('x', middleOfBarFromStartWidth - overChartDifferenceWidth)
                }
              }, 50)
            }

            // Hide label if bar is gone
            return isGone ? '' : name;
          },
          style: {
            colors: ["#f3f4f5", "#fff"],
          },
        },
        xaxis: {
          type: "datetime",
          min: this.xAxisMin,
          max: this.xAxisMax,
          show: false,
          // position: "top",
          axisTicks: {
            show: false,
            borderType: "solid",
          },
          labels: {
            show: false,
            // formatter: function (val, timestamp) {
            //   return moment(new Date(val)).format("DD/MM/yyyy");
            // },
          },
        },
        yaxis: {
          show: false,
        },
        grid: {
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
      };
    },
    dataAnnotations: function () {
      let length = parseFloat(this.length) / 100;
      let event = this.hadEvent;

      let min = Math.round(20 * length * length);
      let max = Math.round(25 * length * length);
      return [
        // weight
        [{ min, max, color: "#66DA26" }],
        // lipids
        this.lipidsUnitSetting === UCUMUnit.MILLIGRAM_PER_DECILITER.unit
          ? event
            // Convert from mmol/l to mg/dl - multiply by 38.67
            ? [{ min: 0.1, max: 1 * 38.67, color: "#66DA26" }]
            : [{ min: 0.1, max: 1.4 * 38.67, color: "#66DA26" }]
          : event
            ? [{ min: 0.1, max: 1, color: "#66DA26" }]
            : [{ min: 0.1, max: 1.4, color: "#66DA26" }],
        // glucose
        this.glucoseUnitSetting === UCUMUnit.PERCENT.unit
          ? [{ min: 0.1, max: 6, color: "#66DA26" }]
          // Convert from % to mmol/mol - 10,93 (HbA1c in %)–23,5 mmol/mol
          : [{ min: 0.1, max: (10.93 * 6) - 23.5, color: "#66DA26" }],
        // blood pressure
        [{ min: 100, max: 130, color: "#66DA26" }],
      ];
    },
    chartHasLegends() {
      const hasData = this.series.some(item => item.data && item.data.length);
      const hasMultipleSeries = this.series.length > 1;
      return hasData && hasMultipleSeries;
    }
  },
  created() {
    this.routeSelectedParameter = this.$route.params.selectedparameter
      ? this.$route.params.selectedparameter
      : null;
  },
  data: function () {
    return {
      timelineColors: [
        this.$color.coro["lightgray2"],
        this.$color.coro["primary-200"],
        this.$color.coro["primary-300"],
        this.$color.coro["primary-400"],
        this.$color.coro["primary-500"],
      ],

      selectedParameterValue: this.p || "blood_pressure",
      selectedParameterIndex: 3,
      selectedParameterUnit: UCUMUnit.MILLIMETER_OF_MERCURY.translate(this.$t),
      keysParametersSelect: [
        {
          value: "weight",
          text: this.$ucfirst(this.$t("parameters.weight", { catalog : 'content'})),
        },
        {
          value: "lipids",
          text: this.$ucfirst(this.$t("parameters.lipids", { catalog : 'content'})),
        },
        {
          value: "glucose",
          text: this.$ucfirst(this.$t("parameters.glucose", { catalog : 'content'})),
        },
        {
          value: "blood_pressure",
          text: this.$stripHTML(this.$ucfirst(this.$t("general.bloodPressure", { catalog : 'app_mobile'}))),
        },
      ],

      loincCodesParameters: [
        "29463-7",
        ["2093-3", "2085-9", "18262-6"],
        "4548-4",
        "85354-9",
      ],

      selectedPeriodValue: "month",
      keysPeriodSelect: [
        {
          value: "month",
          text: this.$t("general.month", {catalog: "app_mobile"}),
        },
        {
          value: "3_months",
          text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 3 } }),
        },
        {
          value: "6_months",
          text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 6 } }),
        },
        {
          value: "year",
          text: this.$t("knowledge.questions.smokecessation.advanced.bloodpressure.answers.oneYear", { catalog: 'content' }),
        },
        {
          value: "full",
          text: this.$t("progressVisualPeriods.fullTime", { catalog: 'app_mobile' }),
        },
      ],
      keysPeriodsSelect: [
        [
          {
            value: "month",
            text: this.$t("general.month", {catalog: "app_mobile"}),
          },
          {
            value: "3_months",
            text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 3 } }),
          },
          {
            value: "6_months",
            text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 6 } }),
          },
          {
            value: "year",
            text: this.$t("knowledge.questions.smokecessation.advanced.bloodpressure.answers.oneYear", { catalog: 'content' }),
          },
          {
            value: "full",
            text: this.$t("progressVisualPeriods.fullTime", { catalog: 'app_mobile' }),
          },
        ],
        [
          {
            value: "full",
            text: this.$t("progressVisualPeriods.fullTime", { catalog: 'app_mobile' }),
          },
        ],
        [
          {
            value: "full",
            text: this.$t("progressVisualPeriods.fullTime", { catalog: 'app_mobile' }),
          },
        ],
        [
          {
            value: "month",
            text: this.$t("general.month", {catalog: "app_mobile"}),
          },
          {
            value: "3_months",
            text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 3 } }),
          },
          {
            value: "6_months",
            text: this.$t("progressVisualPeriods.numberOfMonths", { catalog: 'app_mobile', params: { numberOfMonths: 6 } }),
          },
          {
            value: "year",
            text: this.$t("knowledge.questions.smokecessation.advanced.bloodpressure.answers.oneYear", { catalog: 'content' }),
          },
          {
            value: "full",
            text: this.$t("progressVisualPeriods.fullTime", { catalog: 'app_mobile' }),
          },
        ],
      ],

      selectedParameterRelatedBehaviourChangeGoals: [
        "STARTMOVING",
        "HEALTHYNUTRITION",
      ],
      parameterRelatedBehaviourChangeGoals: [
        ["STARTMOVING", "HEALTHYNUTRITION"],
        ["MEDICATIONS", "STARTMOVING", "HEALTHYNUTRITION"],
        ["MEDICATIONS", "STARTMOVING", "HEALTHYNUTRITION"],
        [
          "MEDICATIONS",
          "STARTMOVING",
          "HEALTHYNUTRITION",
          "SMOKECESSATION",
          "STRESSMANAGEMENT",
        ],
      ],
      behaviourComponents: {
        MEDICATIONS: { name: "MEDICATIONS", icon: "mdi-pill" },
        STARTMOVING: { name: "STARTMOVING", icon: "mdi-run" },
        HEALTHYNUTRITION: {
          name: "HEALTHYNUTRITION",
          icon: "mdi-silverware-fork-knife",
        },
        SMOKECESSATION: { name: "MEDICATIONS", icon: "mdi-smoking-off" },
        STRESSMANAGEMENT: { name: "SMOKECESSATION", icon: "mdi-meditation" },
      },
      series: [
        {
          name: "Session Duration",
          data: [],
        },
      ],
      // Timeline chart data
      seriesTimeLine: [
        {
          data: [],
        },
      ],
      yAxisOverTimeMin: undefined,
      yAxisOverTimeMax: undefined,
      xAxisMin: moment().subtract(1, "month").valueOf(),
      xAxisMax: moment().valueOf(),
      lowestValueSeries: 999,
      highestValueSeries: 0,
      journeyProgress: null,
      legends: [],
      timelineWidth: null,
      legendWidth: 0,
      yAxisWidth: 0
    };
  },
  methods: {
    getBehaviourComponentLabel(labelKey, name) {
      let _LOG = name == " " ? "0" : name;
      let LOG_name = this.getLevelOfGuidanceLabel(_LOG, labelKey)

      return (
        `${this.$app.behaviourComponentManager.getBehaviourComponentName(labelKey)}
         ${this.$t("journeyProgress.levelOfGuidance")}
         ${_LOG}${LOG_name ? ' - ' + LOG_name : ''}: `
      );
    },
    parameterChange() {
      let index = this.keysParametersSelect.findIndex(
        (parameter) => parameter.value === this.selectedParameterValue
      );
      this.selectedParameterIndex = index;
      // Only set periods relevant to patient visit1Date
      let _periods = this.keysPeriodsSelect[index];
      if (_periods.length > 1) {
        if (this.visit1Date.isAfter(moment().subtract(1, "months"))) {
          _periods = _periods.slice(0, 1);
        } else if (
          this.visit1Date.isAfter(moment().subtract(3, "months"))
        ) {
          _periods = _periods.slice(0, 2);
        } else if (
          this.visit1Date.isAfter(moment().subtract(6, "months"))
        ) {
          _periods = _periods.slice(0, 3);
        } else if (this.visit1Date.isAfter(moment().subtract(1, "year"))) {
          _periods = _periods.slice(0, 4);
        }
      }
      const defaultPeriodValue = this.getDefaultPeriodValue();
      const defaultPeriodAvailable = _periods.find(item => item.value === defaultPeriodValue);

      this.keysPeriodSelect = _periods;
      // select default period if possible, otherwise shortest period
      this.selectedPeriodValue = defaultPeriodAvailable?.value || _periods[0].value;
      this.selectedParameterRelatedBehaviourChangeGoals =
        this.parameterRelatedBehaviourChangeGoals[index];
      this.loadGraphData();
      this.setTimeLineSeries();

      this.setLegendWidth();
      this.setYAxisWidth();
    },
    periodChange() {
      this.loadGraphData();
    },

    async loadGraphData() {
      this.series = [];
      switch (this.selectedParameterValue) {
        case "weight": {
          const data = await this.loadParameterData(
            this.loincCodesParameters[this.selectedParameterIndex],
            this.weightUnitSetting
          );
          // Calculate lowest and highest value from dataSet points (not individual points)
          this.getHighestAndLowestValueSeriesData(data);
          this.series = [{ name: this.$t('parameters.weight', {catalog: 'content'}), data: data }];
          break;
        }
        case "lipids": {
          let promises = this.loincCodesParameters[
            this.selectedParameterIndex
          ].map(async (code) => {
            return this.loadParameterData(code, this.lipidsUnitSetting);
          });
          let data = await Promise.all(promises);
          this.getHighestAndLowestValueSeriesData(data);
          this.series = [
            { name: this.$t('parameters.total_cholesterol', {catalog: 'content'}), data: data[0] || [] },
            { name: this.$t('parameters.LDL', {catalog: 'content'}), data: data[2] || [] },
            { name: this.$t('parameters.HDL', {catalog: 'content'}), data: data[1] || [] },
          ];
          break;
        }
        case "glucose": {
          const data = await this.loadParameterData(
            this.loincCodesParameters[this.selectedParameterIndex],
            this.glucoseUnitSetting
          );
          this.getHighestAndLowestValueSeriesData(data);
          this.series = [{ name: this.$t('parameters.glucose', {catalog: 'content'}), data: data }];
          break;
        }
        case "blood_pressure": {
          const data = await this.loadParameterData(
            this.loincCodesParameters[this.selectedParameterIndex],
            this.bloodPressureUnitSetting
          );
          this.getHighestAndLowestValueSeriesData(data);
          this.series = [
            { name: this.$t('reportParametersHomeScreen.diastolic', {catalog: 'app_mobile'}), data: data[1] || [] },
            { name: this.$t('reportParametersHomeScreen.systolic', {catalog: 'app_mobile'}), data: data[0] || [] },
          ];
          break;
        }
      }
    },

    async loadParameterData(loincCode, unit) {
      let _beginDate = moment();
      switch (this.selectedPeriodValue) {
        case "week": {
          _beginDate.subtract(1, "week");
          break;
        }
        case "month": {
          _beginDate.subtract(1, "month");
          break;
        }
        case "3_months": {
          _beginDate.subtract(3, "month");
          break;
        }
        case "6_months": {
          _beginDate.subtract(6, "month");
          break;
        }
        case "year": {
          _beginDate.subtract(1, "year");
          break;
        }
        case "full": {
          _beginDate = this.visit1Date;
          break;
        }
      }
      this.xAxisMin = _beginDate.valueOf();
      // Only way to fix label outside bar is to set max higher --> losing place to display data
      // const timelinePeriod = moment().diff(_beginDate);
      // const addAmount = timelinePeriod / 18
      // this.xAxisMax = moment().add(addAmount).valueOf();

      this.xAxisMax = moment().valueOf();

      return this.$app.apolloMobileClient
        .query({
          query: gql`
            query myHealthParametersQuery(
              $conditions: RelayObservationCondition!
              $conversion: [UnitConversionRule!]
              $patientId: String!
            ) {
              myHealthParameters(
                conditions: $conditions
                orders: [{field: effectiveDateTime, direction : asc}]
                functions: [{ function: patientId, parameters: [$patientId] }]
              ) {
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                  startCursor
                  endCursor
                }
                edges {
                  cursor
                  node {
                    id
                    locked
                    status
                    effectiveDateTime
                    valueQuantity(conversion: $conversion) {
                      code
                      value
                    }
                    code {
                      coding {
                        code
                      }
                    }
                    component {
                      valueQuantity {
                        code
                        value
                      }
                      code {
                        coding {
                          code
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: {
            patientId: this.patientId.toString(),
            conversion: [{ toUnit: unit }],
            conditions: {
              gate: "and",
              inputs: [
                {
                  field: "code",
                  value: loincCode,
                },
                {
                  field: "effectiveDateTime",
                  operator: "between",
                  parameters: [
                    `${_beginDate.format("YYYY-MM-DD")} 00:00:00`,
                    `${moment().add(1, "day").format("YYYY-MM-DD")} 23:59:59`,
                  ],
                },
              ],
            },
          },
        })
        .then((result) => {
          let _formattedResult = [];
          _formattedResult = this.formatDataForGraph(result.data);
          return Promise.resolve(_formattedResult);
        });
    },

    formatDataForGraph(data) {
      let dataSet = [];
      let dataSet2 = [];
      data.myHealthParameters.edges.map((param) => {
        let parameterValue = param.node.valueQuantity?.value;
        let parameterValue2 = null;
        // For blood pressure
        if (parameterValue == null) {
          parameterValue = param.node.component[0].valueQuantity.value;
          parameterValue2 = param.node.component[1].valueQuantity.value;
        }

        let groupBy = this.getDataPointGroupPeriod();
        let labelName = moment(param.node.effectiveDateTime)
          .startOf(groupBy)
          .add(5, "hour")
          .valueOf();

        const isXAxisMinAfterFirstDataPoint = moment(this.xAxisMin).isAfter(labelName);
        // To make sure that 1st dataPoint is inside the graph
        if (isXAxisMinAfterFirstDataPoint) {
          this.xAxisMin = labelName;
        }

        if (dataSet.length != 0 && dataSet[dataSet.length - 1].x == labelName) {
          let last = dataSet.length - 1;
          dataSet[last] = {
            x: dataSet[last].x,
            y: parseFloat(((dataSet[last].y + parameterValue) / 2).toFixed(1)),
          };
          if (parameterValue2) {
            dataSet2[last] = {
              x: dataSet2[last].x,
              y: parseFloat(
                ((dataSet2[last].y + parameterValue2) / 2).toFixed(1)
              ),
            };
          }
        } else {
          dataSet.push({ x: labelName, y: parameterValue });
          if (parameterValue2) {
            dataSet2.push({ x: labelName, y: parameterValue2 });
          }
        }
      });
      if (dataSet2.length > 0) {
        return [dataSet, dataSet2];
      }
      return dataSet;
    },

    setAnnotationsGraph() {
      let _annotations = [];
      this.dataAnnotations[this.selectedParameterIndex].map((annotation) => {
        _annotations.push({
          y: annotation.min,
          y2: annotation.max,
          borderColor: "#000",
          fillColor: annotation.color,
        });
      });

      return _annotations;
    },

    getYAxisTitle() {
      let _unit = UCUMUnit.MILLIMETER_OF_MERCURY.translate(this.$t);
      let title = this.keysParametersSelect[this.selectedParameterIndex].text;
      switch (this.selectedParameterValue) {
        case "weight": {
          _unit = this.weightUnitSetting;
          break;
        }
        case "glucose": {
          _unit = this.glucoseUnitSetting;
          break;
        }
        case "lipids": {
          _unit = this.lipidsUnitSetting;
          title = this.$ucfirst(this.$t(
            'questionnaires.INFORMATION_PREFERENCES.topic.CHOLESTEROL',
            { catalog: "questionnaires" }
          ));
          break;
        }
        case "blood_pressure": {
          _unit = UCUMUnit.MILLIMETER_OF_MERCURY.translate(this.$t)
          break;
        }
      }
      this.selectedParameterUnit = _unit;
      return `${title} (${_unit})`;
    },

    getHighestAndLowestValueSeriesData(data, returnValue = false) {
      // Calculate lowest and highest value from dataSet points
      let _lowestValue = 999;
      let _highestValue = 0;
      if (data[0]?.y) {
        _lowestValue = data.reduce(
          (min, p) => (p.y < min ? p.y : min),
          data[0].y
        );
        _highestValue = data.reduce(
          (min, p) => (p.y > min ? p.y : min),
          data[0].y
        );
      } else {
        data.forEach((dataArray) => {
          if (dataArray[0]?.y) {
            let _lowestValueLocal = dataArray.reduce(
              (min, p) => (p.y < min ? p.y : min),
              dataArray[0].y
            );
            let _highestValueLocal = dataArray.reduce(
              (min, p) => (p.y > min ? p.y : min),
              dataArray[0].y
            );
            if (_lowestValue > _lowestValueLocal)
              _lowestValue = _lowestValueLocal;
            if (_highestValue < _highestValueLocal)
              _highestValue = _highestValueLocal;
          }
        });
      }
      if (_lowestValue == _highestValue) {
        _highestValue += _highestValue;
      }
      if (returnValue) {
        return { _lowestValue, _highestValue };
      } else {
        this.lowestValueSeries = _lowestValue;
        this.highestValueSeries = _highestValue;
        this.setYAxisRange();
      }
    },

    async getTimeLineData() {
      await this.$store.dispatch('patientSummary/getEventData', this.patientId);

      this.$app.apolloMobileClient
        .query({
          query: gql`
            query myBehaviourComponentLogs($patientId: String!) {
              myBehaviourComponentLogs(
                orders: [{ field: createdAt, direction: asc }]
                functions: [{ function: patientId, parameters: [$patientId] }]
              ) {
                logId
                oldLevel
                newLevel
                createdAt
                component {
                  key
                }
              }
            }
          `,
          variables: {
            patientId: this.patientId,
          },
        })
        .then((result) => {
          this.myBehaviourComponentLogs = result;
          this.setTimeLineSeries();
        });
    },

    setTimeLineSeries() {
      if (this.myBehaviourComponentLogs) {
        let _splitSeries = {
          0: [],
          1: [],
          2: [],
          3: [],
          4: [],
        };
        Object.keys(this.behaviourComponents).map(
          (behaviourComponent, index) => {
            // For every behaviourComponent filter myBehaviourComponentLogs on the behaviourComponent
            let behaviourComponentSpecificLogs =
              this.myBehaviourComponentLogs.data.myBehaviourComponentLogs.filter(
                (log) => {
                  return log.component.key == behaviourComponent;
                }
              );
            // Loop all changes for specific behaviourComponent
            behaviourComponentSpecificLogs.map((log, specificIndex) => {
              let level = parseInt(log.newLevel);

              // Only 1 LOG
              if (behaviourComponentSpecificLogs.length == 1) {
                _splitSeries[index].push({
                  x: log.component.key,
                  y: [moment(log.createdAt).valueOf(), moment().valueOf()],
                  name:
                    level.toString() != "0"
                      ? level.toString()
                      : " ",
                  fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS'),
                });
              } else {
                // If LOG is last
                if (
                  specificIndex ==
                  behaviourComponentSpecificLogs.length - 1
                ) {
                  _splitSeries[index].push({
                    x: log.component.key,
                    y: [moment(log.createdAt).valueOf(), moment().valueOf()],
                    name:
                      level.toString() != "0"
                        ? level.toString()
                        : " ",
                    fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS'),
                  });
                } else {
                  _splitSeries[index].push({
                    x: log.component.key,
                    y: [
                      moment(log.createdAt).valueOf(),
                      moment(
                        behaviourComponentSpecificLogs[specificIndex + 1]
                          .createdAt
                      ).valueOf(),
                    ],
                    name:
                      level.toString() != "0"
                        ? level.toString()
                        : " ",
                    fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS')
                  });
                }
              }
            });
            // Add LOG 0 from beginning of enrollment untill first change
            if (
              _splitSeries[index][0] != null &&
              moment(_splitSeries[index][0].y[0]).isAfter(this.visit1Date)
            ) {
              _splitSeries[index].unshift({
                x: behaviourComponent,
                y: [
                  this.visit1Date.valueOf(),
                  moment(_splitSeries[index][0].y[0]).valueOf(),
                ],
                name: " ",
                fillColor: this.timelineColors[0],
              });
            }
          }
        );
        // Create series object
        let _series = [
          // ..._splitSeries[0],
          // ..._splitSeries[1],
          // ..._splitSeries[2],
          // ..._splitSeries[3],
          // ..._splitSeries[4],
        ];
        // Only add the related behaviour goals to the series data
        this.selectedParameterRelatedBehaviourChangeGoals.map((relatedGoal) => {
          if (
            Object.keys(this.behaviourComponents).indexOf(relatedGoal) != -1
          ) {
            _series.push(
              ..._splitSeries[
                Object.keys(this.behaviourComponents).indexOf(relatedGoal)
              ]
            );
          }
        });

        const legends = [];
        _series.forEach(item => {
          const isMedication = item.x === 'MEDICATIONS';
          if (item.name && !legends.find(i => i.name === this.getLevelOfGuidanceName(+item.name, isMedication))) {

            // adjust sorting for MEDICATIONS
            let sortKey = +item.name;
            if (isMedication && sortKey === 1) {
              sortKey = 2;
            } else if (isMedication && +sortKey === 2) {
              sortKey = 3;
            }

            legends.push({
              sortKey: sortKey,
              name: this.getLevelOfGuidanceName(+item.name, isMedication),
              color: item.fillColor
            })
          }
        })
        const sorted = legends.sort((a,b) => (a.sortKey > b.sortKey) ? 1 : ((b.sortKey > a.sortKey) ? -1 : 0))
        this.legends = sorted;

        this.seriesTimeLine = [
          {
            data: _series,
          },
        ];
      }
    },

    setLegendWidth() {
      // needed to align parameter chart with timeline
      const legends = this.$refs.timelineLegends;
      this.legendWidth = legends.clientWidth;
    },

    setYAxisWidth() {
      // needed to align parameter chart with timeline
      const icons = this.$refs.timelineIcons;
      this.yAxisWidth = icons.clientWidth;
    },

    getDefaultPeriodValue() {
      let defaultPeriod = ''
      switch (this.selectedParameterValue) {
        case "lipids":
        case "glucose":
          defaultPeriod = 'full'
          break;
        case "weight":
          defaultPeriod = '3_months'
          break;
        case "blood_pressure":
          defaultPeriod = 'month'
          break;
      }
      return defaultPeriod;
    },

    getLevelOfGuidanceName(log, isMedication) {
      switch(log) {
        case 0:
          return this.$t('physicalActivityStepGoals.inactive', { catalog: 'app_mobile' })
        case 1:
          if (isMedication) {
            return this.$t('journeyBehaviourChangeGoals.monitoredAction')
          } else {
            return this.$t('journeyBehaviourChangeGoals.startAction')
          }
        case 2:
          if (isMedication) {
            return this.$t('journeyBehaviourChangeGoals.maintainedBehavior')
          } else {
            // Note: LOG change
            // Used to be 'Planned action'
            return this.$t('journeyBehaviourChangeGoals.monitoredAction')
          }
        case 3:
          return this.$t('journeyBehaviourChangeGoals.maintainedBehavior')
        default:
          return '';
      }
    },

    getLevelOfGuidanceColor(log, isMedication) {
      if (isMedication && log) {
        return this.timelineColors[log + 1]
      }
      return this.timelineColors[log]
    },

    getLevelOfGuidanceLabel(log, key) {
      const isMedication = key === 'MEDICATIONS'

      switch(log) {
        case '1':
          return isMedication
            ? this.$ucfirst(this.$t(
                'journeyFormulationAdherence.optimiseAdherence',
                { catalog: 'app_mobile' }
              ))
            : this.$ucfirst(this.$t(
                'journeyFormulation.learn', { catalog: 'app_mobile' }
              ))
        case '2':
          return isMedication
            ? this.$ucfirst(this.$t(
                'journeyFormulationAdherence.maintainHealthyHabit',
                { catalog: 'app_mobile' }
              ))
              // Note: LOG change
              // Used to be 'Plan your exercise'
            : this.$ucfirst(this.$t(
                'journeyFormulation.trackGoals', { catalog: 'app_mobile' }
              ))
        case '3':
          return this.$ucfirst(this.$t(
            'journeyFormulationAdherence.maintainHealthyHabit',
            { catalog: 'app_mobile' }
          ))
        default:
          return this.$ucfirst(this.$t(
              'physicalActivityStepGoals.inactive',
              { catalog: 'app_mobile' }
          ))
      }
    },

    getLineChartColors() {
      const colors = ['#008ffb', '#00e396', '#feb019'];
      let selectedColors = [];

      switch (this.selectedParameterValue) {
        case "weight":
          selectedColors = [colors[1]]
          break;
        case "glucose":
          selectedColors = [colors[1]]
          break;
        default:
          selectedColors = colors;
          break;
      }

      return selectedColors;
    },

     getDataPointGroupPeriod() {
      let period = '';
      switch (this.selectedPeriodValue) {
        case "week":
        case "month":
          period = 'day'
          break;
        case "3_months":
        case "6_months":
          period = 'isoWeek'
          break;
        case "year":
        case "full":
          period = 'month'
          break;
      }
      return period;
    },

    getParameterValuePrecision() {
      let precision = 0;
      switch (this.selectedParameterValue) {
        case "weight":
        case "glucose":
          precision = 1
          break;
        case "lipids":
          precision = this.lipidsUnitSetting === UCUMUnit.MILLIGRAM_PER_DECILITER.unit
            ? 1
            : 2
          break;
        case "blood_pressure":
          precision = 0
          break;
      }
      return precision;
    },

    getYAxisMinMaxValues() {
      let min = undefined;
      let max = undefined;
      let length = parseFloat(this.length) / 100;

      switch (this.selectedParameterValue) {
        case "weight":
          if (!isNaN(length)) {
            min = 12 * length * length;
            max = 60 * length * length;
          }
          break;
        case "glucose":
          min = this.glucoseUnitSetting === UCUMUnit.PERCENT.unit
            ? 2.15 // %
            : 10.93 * 2.15 - 23.5 // mmol/L
          max = this.glucoseUnitSetting === UCUMUnit.PERCENT.unit
            ? 20 // %
            : 10.93 * 20 - 23.5 // mmol/L
          break;
        case "lipids":
          min = this.lipidsUnitSetting === UCUMUnit.MILLIGRAM_PER_DECILITER.unit
            ? 10 // mg/dL
            : 10 / 38.67 // mmol/L
          max = this.lipidsUnitSetting === UCUMUnit.MILLIGRAM_PER_DECILITER.unit
            ? 450 // mg/dL
            : 450 / 38.67 // mmol/L
          break;
        case "blood_pressure":
          min = 30;
          max = 280;
          break;
      }
      return { min, max };
    },

    setYAxisRange() {
      // When data series is set check if the annotation ranges are visible
      let {min, max} = this.getYAxisMinMaxValues();
      let _annotations = this.setAnnotationsGraph();
      let _lowestValueAnnotation = _annotations.reduce(
        (min, p) => (p.y < min ? p.y : min),
        _annotations[0].y
      );
      let _highestValueAnnotation = _annotations.reduce(
        (min, p) => (p.y2 > min ? p.y2 : min),
        _annotations[0].y2
      );
      if (_lowestValueAnnotation >= this.highestValueSeries && _lowestValueAnnotation >= max) {
        this.yAxisOverTimeMax =
          _lowestValueAnnotation +
          ((this.highestValueSeries - this.lowestValueSeries) / 100) * 10;
      } else {
        this.yAxisOverTimeMax = max;
      }
      if (_highestValueAnnotation <= this.lowestValueSeries && _highestValueAnnotation <= min) {
        this.yAxisOverTimeMin = Math.max(
          0,
          _highestValueAnnotation -
            ((this.highestValueSeries - this.lowestValueSeries) / 100) * 20
        );
      } else {
        this.yAxisOverTimeMin = min;
      }
    }
  },

  mounted: async function () {
    // this.fetchUnitsPatient();
    // const journeyCalculator = this.$app.patientManager.makeJourneyCalculator(
    //   this.patientId,
    //   this.visit1Date
    // );

    // await journeyCalculator.loadMyBehaviourComponentLogs();
    // this.journeyProgress = journeyCalculator.journeyProgress;
    this.loadGraphData();
    this.getTimeLineData();
    this.parameterChange();
    // this.setTimeLineSeries(this.journeyProgress);
  },
  beforeRouteUpdate(to, from, next) {
    const nextParam = to.params.p
    if (nextParam) {
      this.selectedParameterValue = nextParam
      this.parameterChange();
    }
    next()
  },
  components: {
    apexchart: VueApexCharts,
    SmartIcon,
  },
};
</script>

<style lang="scss">
.progress-parameters {
  min-height: 526px;
}
.progress-parameters__related-goals {
  font-size: 0.9rem;
}

.c-timeline__icon {
  margin-bottom: 13px;
}

.progress-parameters__timeline .apexcharts-tooltip-rangebar {
  font-size: 0.85rem;
}
</style>
